import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { IconInduxtryComponent } from '../icon-induxtry/icon-induxtry.component';
import type { iconInterface } from '../icon-induxtry/icon-induxtry.component';

export type IconActionButtonType = 'neutral' | 'action' | 'delete';

@Component({
  selector: 'icon-action-button',
  templateUrl: './icon-action-button.component.html',
  styleUrls: ['./icon-action-button.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconInduxtryComponent],
})
export class IconActionButtonComponent {
  /** Tipo do botão: neutral, action ou delete. */
  type = input.required<IconActionButtonType>();

  /** Nome do ícone (obrigatório para neutral e action; ignorado para delete). */
  icon = input<string>();

  /** Label para acessibilidade. */
  ariaLabel = input<string>();

  /** Desabilita o botão (classe .disabled + atributo disabled). */
  disabled = input<boolean>(false);

  /** Preenche o ícone com a cor primária. */
  customFill = input<boolean>(false);

  sizeIcon = input<number>(24);

  /** Ícone efetivo: sempre "delete" para tipo delete, senão o valor do input icon. */
  effectiveIcon = computed(() =>
    this.type() === 'delete' ? 'delete' : this.icon()
  );

  /** Configuração passada ao icon-induxtry. */
  iconConfig = computed<iconInterface | undefined>(() => {
    const name = this.effectiveIcon();
    if (!name) return undefined;
    return { icon: name, width: this.sizeIcon(), height: this.sizeIcon() };
  });

  /** Emitido ao clicar ou ativar por teclado. */
  clicked = output<Event>();

  handleClick(event: Event): void {
    if (this.disabled()) return;
    this.clicked.emit(event);
  }

  handleKeydown(event: KeyboardEvent): void {
    if (this.disabled()) return;
    event.preventDefault();
    this.clicked.emit(event as unknown as Event);
  }
}
